export const ReceptionFileType = {
  prescription: 'prescription',
  insuranceCard: 'insuranceCard',
  questionnaire: 'questionnaire',
} as const;
